export const TRACKING_EVENT = {
	OPEN_SITEMAP_EDITOR: 'OPEN_SITEMAP_EDITOR',
	SEARCH_SITEMAP: 'SEARCH_SITEMAP',
	NAVIGATE_TO_PAGE: 'NAVIGATE_TO_PAGE',
	CANCEL_PAGE_DETAILS: 'CANCEL_PAGE_DETAILS',
	SAVE_PAGE_DETAILS: 'SAVE_PAGE_DETAILS',
	ENTER_MANAGE_MODE: 'ENTER_MANAGE_MODE',
	DELETE_PAGES: 'DELETE_PAGES',
	EXPORT_SITEMAP_CSV: 'EXPORT_SITEMAP_CSV',
	SAVE_BATCH_EDIT: 'SAVE_BATCH_EDIT',
	CANCEL_BATCH_EDIT: 'CANCEL_BATCH_EDIT'
} as const;

export const TRACKING_FIELD = {
	PP_EN: 'PP_en',
	PP_ES: 'PP_es',
	PP_FR: 'PP_fr',
	PAGE_ALIAS: 'Page_Alias',
	PAGE_ID: 'Page_Id',
	HTML: 'HTML',
	XML: 'XML',
	XML_ADD_DATE: 'XML_add_date',
	XML_REMOVE_DATE: 'XML_remove_date',
	NO_INDEX: 'No_index',
	NO_FOLLOW: 'No_follow'
} as const;
